<div nz-row class="login-box" nzType="flex" nzJustify="center">
  <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
    <h1>{{ 'app.login.title' | translate }}</h1>
    <button
      nz-button
      [nzSize]="'large'"
      [nzType]="'primary'"
      class="login-button"
      (click)="signin()"
    >
      {{ 'app.login.login' | translate }}
    </button>
  </nz-card>
</div>
